class CountdownTimer extends HTMLElement {
  connectedCallback() {
    const year = parseInt(this.dataset.year, 10);
    const month = parseInt(this.dataset.month, 10); // 01-12
    const day = parseInt(this.dataset.day, 10);
    const hour = parseInt(this.dataset.hour || "0", 10);
    const minute = parseInt(this.dataset.minute || "0", 10);

    const hideTimer = (this.dataset.hideTimer || "false") === "true";
    const completeMessage = this.dataset.completeMessage || "";

    // Month is 0-based in JS dates
    const end = new Date(year, month - 1, day, hour, minute, 0);

    const display = this.querySelector("[data-time-display]");
    if (!display || isNaN(end.getTime())) {
      this.style.display = "none";
      return;
    }

    const dayEl = this.querySelector("[date-days-placeholder]");
    const hourEl = this.querySelector("[date-hours-placeholder]");
    const minEl = this.querySelector("[date-minutes-placeholder]");
    const secEl = this.querySelector("[date-seconds-placeholder]");

    const pad = (n) => String(n).padStart(2, "0");

    const tick = () => {
      const now = new Date();
      const diff = end.getTime() - now.getTime();

      if (diff <= 0) {
        if (hideTimer) {
          this.style.display = "none";
        } else if (completeMessage) {
          display.innerHTML = `<div class="countdown__complete">${completeMessage}</div>`;
        }
        clearInterval(this._int);
        return;
      }

      const total = Math.floor(diff / 1000);
      const days = Math.floor(total / 86400);
      const hours = Math.floor((total % 86400) / 3600);
      const minutes = Math.floor((total % 3600) / 60);
      const seconds = total % 60;

      if (dayEl) dayEl.textContent = days;
      if (hourEl) hourEl.textContent = pad(hours);
      if (minEl) minEl.textContent = pad(minutes);
      if (secEl) secEl.textContent = pad(seconds);

      display.classList.add("countdown__display--visible");
    };

    tick();
    this._int = setInterval(tick, 1000);
  }

  disconnectedCallback() {
    if (this._int) clearInterval(this._int);
  }
}

customElements.define("countdown-timer", CountdownTimer);
